import { gql } from '@apollo/client';

export const GENERATE_BULK_TRADES = gql`
  mutation generateBulkTrades($input: GenerateBulkTradesInput!) {
    generateBulkTrades(input: $input) {
      bulkTradeRun {
        id
      }
    }
  }
`;
